function trim(name: string): string {
  return name ? name.replace(/^\s+|\s+$/g, "") : name;
}

function testIfFileName(name: string): boolean {
  const dot = name.lastIndexOf(".");
  return 0 < dot && 5 >= name.length - dot && name.length !== dot + 1;
}

export function truncateFileName(
  name: string,
  maxLength: number = 12,
  ending = "...",
): string {
  name = trim(name);
  ending = trim(ending);
  if (maxLength && name.length <= maxLength) return name;
  maxLength = Math.max(maxLength - ending.length, 0);
  if (testIfFileName(name)) {
    const dot = name.lastIndexOf(".");
    let truncatedString = "";
    maxLength = Math.max(maxLength - name.slice(dot).length, 0);
    truncatedString += name.slice(0, dot).slice(0, Math.ceil(maxLength / 2));
    truncatedString += ending;
    truncatedString += name.slice(0, dot).slice(0 - Math.floor(maxLength / 2));
    truncatedString += name.slice(dot);
    return truncatedString;
  }
  return name.slice(0, maxLength) + ending;
}
